import { TableCell, TableRow, Typography } from '@mui/material';

const SubmissionItem = ({ submission, handleClick }) => {
	return (
		<TableRow hover onClick={() => handleClick(submission)}>
			<TableCell>
				<Typography variant="primary.text">
					{submission?.user?.first_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{submission?.user?.last_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{submission?.event?.name}
				</Typography>
			</TableCell>
		</TableRow>
	);
};

export default SubmissionItem;
